import { useEffect, useState } from "react";
import { HOME } from "@/constants/testIds";

const TARGET = new Date("2026-07-04T19:30:00+02:00").getTime();

function calc() {
  const diff = Math.max(0, TARGET - Date.now());
  const days = Math.floor(diff / (1000 * 60 * 60 * 24));
  const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
  const minutes = Math.floor((diff / (1000 * 60)) % 60);
  const seconds = Math.floor((diff / 1000) % 60);
  return { days, hours, minutes, seconds };
}

const Tile = ({ value, label, testId }) => (
  <div className="num-tile bg-[#0E1410] text-[#F7F1E8] px-4 py-3 sm:px-6 sm:py-5 flex flex-col items-center min-w-[78px] sm:min-w-[110px] border-l-4 border-[#E94E1B]">
    <span data-testid={testId} className="font-black text-3xl sm:text-5xl tabular-nums leading-none">
      {String(value).padStart(2, "0")}
    </span>
    <span className="font-display uppercase tracking-[0.18em] text-[10px] sm:text-xs mt-2 text-[#F2B23A]">
      {label}
    </span>
  </div>
);

export default function Countdown() {
  const [t, setT] = useState(calc());
  useEffect(() => {
    const id = setInterval(() => setT(calc()), 1000);
    return () => clearInterval(id);
  }, []);
  return (
    <div className="flex flex-wrap gap-2 sm:gap-3">
      <Tile value={t.days} label="Dies" testId={HOME.heroCountdownDays} />
      <Tile value={t.hours} label="Hores" testId={HOME.heroCountdownHours} />
      <Tile value={t.minutes} label="Minuts" testId={HOME.heroCountdownMinutes} />
      <Tile value={t.seconds} label="Segons" testId={HOME.heroCountdownSeconds} />
    </div>
  );
}
